import React, { Suspense } from 'react';
import moment from 'moment';

import { QueryClientProvider } from '@tanstack/react-query';
import ContextBind from './contexts';
import Router from './routes';
import GlobalStyles from './styles/global';

import { PageContainer } from './components/Layout';

import 'antd/dist/reset.css';
import queryClient from './store/queryClient';
import { FlagsProvider } from './contexts/Flags';
import { ConfigProvider } from './components/Layout/ConfigProvider';
//
moment.locale('pt-br');
//
const App: React.FC = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <ContextBind>
                <ConfigProvider>
                    <GlobalStyles />
                    <Suspense fallback={<div />}>
                        <PageContainer>
                            <FlagsProvider>
                                <Router />
                            </FlagsProvider>
                        </PageContainer>
                    </Suspense>
                </ConfigProvider>
            </ContextBind>
        </QueryClientProvider>
    );
};

export default App;
